import React, { useRef, useState, useImperativeHandle } from "react";
import ModalView from '@/components/modal-view'
import styled from "styled-components";
import ModalBG from '../imgs/common-modal-bg@2x.png';

const CommonModal = React.forwardRef((_, ref) => {
  const [showModal, setShowModal] = useState(false);
  const modalContent = useRef(null);

  useImperativeHandle(ref, () => {
    return {
      show: (content) => {
        modalContent.current = content;
        setShowModal(true);
      },
      close: () => setShowModal(false),
    }
  });

  return (
    <ModalView
      visible={showModal}
      onClose={() => setShowModal(false)}
      content={
        <ModalWrap>
          <div className="modal-content">
            {modalContent.current}
          </div>
        </ModalWrap>
      }
    />
  )
})

const ModalWrap = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 27px;
  color: #333;
  .modal-content {
    position: relative;
    border-radius: 10px;
    padding: 49px 0 17px;
    background-image: url(${ModalBG});
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
`

export default React.memo(CommonModal);




// WEBPACK FOOTER //
// ./src/views/activity_31/components/common-modal.js